import { module } from 'angular';
import App from '../../app';

class UserService {
	
	constructor($q, $state,httpService, utilService,popupService) {
		this.$q = $q;
		this.$state = $state;
		this.utilService = utilService;
		this.httpService = httpService;
		this.popupService = popupService;
	}
	
	getUserPromise(){
		const defer = this.$q.defer();

		this.httpService.get('/logininfosso')
		.then(res =>{
			if(res.isError) defer.reject(res);
			else defer.resolve(this._setUser(res));
		});
		
		return defer.promise;
	}
	
	getUser() {
		return this._user;
	}
	
	requestSignIn(user) {
		const defer = this.$q.defer();
		
		this.httpService.post('/login', user)
						.then(res => {
							if(res.isError) defer.reject(res);
							else defer.resolve(this._setUser(res));
						});
		return defer.promise;
	}
	
	requestLogout(scope) {
		this.popupService.simpleConfirm(scope, 
				"로그아웃 하시겠습니까?",
				()=>{
					this.httpService.post('/logout')
					.then(res => {
						this._removeUser();
						this.$state.go('login');
					});
				});
	}
	
	getUserMenu() {
		return this._menu;
	}
	
	_setUser(loginUserInfo){
		this._menu = loginUserInfo.menuList;
		this._user = loginUserInfo.userDto;
		this._user.locale = loginUserInfo.sessionInfo && typeof loginUserInfo.sessionInfo === 'object' ?  loginUserInfo.sessionInfo.locale : this._getLocale();
		
		return this._user;
	}
	
	_getLocale(){
		let browserLocale = navigator.language || navigator.browserLanguage;
		let user = this._user;
		let locale = user.locale || browserLocale || 'ko';
	
        if (locale.indexOf('ko') !== -1) {
            locale = 'ko';
        } else if (locale.indexOf('en') !== -1) {
            locale = 'en';
        }
	
	    return locale;
	}
	
	_removeUser(){
		delete this._user;
	}
	
	isAdmin(){
		const user = this._user;
		return _.isEmpty(user) ? false : user.roleId === 'Administrator';
	}
	
	manualDown(scope) {
		this.popupService.showLoadingBar(scope);
		this.httpService.downloadFile('/manualDownload').then(res => {
			console.log(res);
			if(res.isError){
				this.popupService.detailAlert(scope, res.data.message, res.data.stackTrace);
			}else{
				var header = decodeURIComponent(res.headers('Content-Disposition'));
				var fileName = header.split("=")[1].replace(/\"/gi,'');
				console.log(fileName);
				
				var blob = new Blob([res.data], {type:"application/pdf"});
				this.utilService.saveFile(blob, fileName);
			}
		})
		.finally(() => {
			this.popupService.closeLoadingBar();
		});
	}
	
	isPerm(){
		const user = this._user;
		return _.isEmpty(user) ? false : user.roleId === 'Administrator' || user.roleId === 'Developer';
	}
}

module(App.name).service('userService', UserService);


// WEBPACK FOOTER //
// ./src/app/common/service/user.service.js